// src/layouts/PrivateLayout.jsx
import React from 'react';
import Header from '../components/Header';
import { Outlet } from 'react-router-dom';

const PrivateLayout = () => {
    return (
        <>
            <Header />
            <main className="min-h-screen bg-gray-50 p-6">
                <Outlet />
            </main>
        </>
    );
};

export default PrivateLayout;
